webpackJsonp([90963236073985],{

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(8);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPage = function BlogPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container' },
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'blog',
	        style: { margin: '0 auto', maxWidth: '70ch', marginBottom: '5em' }
	      },
	      _react2.default.createElement(
	        _Link2.default,
	        { href: '/blog/25-march' },
	        '\u2190 Previous'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Trusting God with Coronavirus'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'author' },
	        'by Abi, 31 March 2020'
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: { fontStyle: 'italic' } },
	        'Abi is part of our Cornerstone church family and has been unwell with suspected Coronavirus. She has now recovered and has shared some reflections on what she has been through and her faith in the Lord Jesus.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Over the past few weeks I\'ve found being a Christian has really helped me deal with all the worrying and upsetting situations I\'ve been in. Firstly, I find it so comforting to know that God always knows what I\'m dealing with and He gives me the strength I need to get through difficult days. It\'s so good to know I\'m not alone.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'I\'ve found it really encouraging being able to pray to God knowing that He hears me and promises to answer. One verse that I\'ve found helpful is Psalm 116 verse 1: "I love the Lord, for he heard my voice; he heard my cry for mercy." Most of all, while I\'m upset that I may not see my friends or family for a few weeks, I\'m thankful that I\'ve been able to look forward to heaven, where there will be no more sickness, and we won\'t have to be separated from our Christian brothers and sisters, but can live together in God\'s presence.'
	      )
	    )
	  );
	};
	
	exports.default = BlogPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-31-march-js-f6332f2ee9b2f1700638.js